import {clone} from 'lodash';
import us from '../../defines';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.rotation-dial');

const defaults = {
  layout: {'divClass': us.clsROTATIONDIV, 'precinct': 'BL', 'order': 2, rightOffset: 20}
};

// NOTE: This control depends upon jquery plugin: knob.js https://github.com/aterrien/jQuery-Knob
export default function RotationDialControl (uScope, viewport, userConfig) {
  var self = this;
  var imageId_ = viewport.getImageId();
  var uScopeIdx_ = viewport.getImageId();

  var isLoaded = false; // rotation dial has been loaded

  var jVpDiv = viewport.vpDivGet('outer');
  var jRotationDiv;
  var jRotationDial;
  var jPresets;

  var navModesImHiddenIn = {}; // what navigation modes not to display the label

  var layout = clone(defaults.layout);
  var reLayout = viewport.overLayout.refreshPrecinct;

  // ............................................ construct_() local
  var construct_ = function () {
    navModesImHiddenIn[us.eNavModes.nmRasterScan] = true;// hide rotation dial in rasterscan mode
    navModesImHiddenIn[us.eNavModes.nmAutoPan] = true; // hide rotation dial in when auto panning
    us.setAnnotNavModes(navModesImHiddenIn); // hide rotation dial when drawing any annotation

    load_(); // load the rotation dial
  };
    // ............................................ show() public
  self.show = function (show) {
    if (isLoaded == false) {
      return;
    }

    // prevent show if preference is not to show
    if (userConfig.get(us.clsROTATIONDIV) == false) jRotationDiv.hide();
    else if (show == true) jRotationDiv.show();
    else jRotationDiv.hide();

    reLayout(layout.precinct); // layout just this overlay's precinct
  };
  // ............................................ rotate() public
  //    This function changes the rotation dial's value as if the user changed it.
  self.setValue = function (angleDeg, animate) {
    if (jRotationDial) {
      angleDeg = angleDeg % 360;
      if (angleDeg < 0) {
        angleDeg += 360;
      }
      jRotationDial.val(angleDeg).trigger('change');

      viewport.viewRotate(angleDeg, {animate}); // ol3 added // when click preset is 0 nothing happens, only 0?
    }
  };

  // ............................................ rotate() public
  //    This function changes the rotation dial's value as if the user changed it.
  self.getValue = function () {
    return parseInt(jRotationDial.val(), 10);
  };

  // ............................................ load_() local
  //    This function creates the rotation dial.
  var load_ = function () {
    if (jRotationDiv) {
      return;
    }

    self.change = viewport.viewRotate;

    self.draw = function () {
      // NOTE: The use of `this` in this function applies to the knob instance, not the rotation dial control instance.
      //
      // Because the rotation control's read out can be edited and that user change does not callback to the change event,
      //    a copy of the angle must be maintained and checked in the draw event and rotate the viewport if necessary.
      var curAngleDeg = viewport.getViewAngle(true);
      if (curAngleDeg != this.cv) {
        viewport.viewRotate(this.cv);
      }
      var a = this.angle(this.cv); // Angle in radians
      var sa = this.startAngle; // Previous start angle
      var sat = this.startAngle; // Start angle
      var ea; // Previous end angle
      var eat = sat + a; // End angle
      var r = 1;

      this.g.lineWidth = this.lineWidth;

      this.o.cursor &&
      (sat = eat - 0.25) &&
      (eat = eat + 0.25);

      var arcWidth = this.radius - this.lineWidth - 5;
      if (this.o.displayPrevious) {
        ea = this.startAngle + this.angle(this.v);
        this.o.cursor &&
        (sa = ea - 0.25) &&
        (ea = ea + 0.25);
        this.g.beginPath();
        this.g.strokeStyle = this.pColor;
        // orig      this.g.arc(this.xy, this.xy, this.radius - this.lineWidth, sa, ea, false);
        this.g.arc(this.xy, this.xy, arcWidth, sa, ea, false);
        this.g.stroke();
      }

      // draw the arc at current angle
      this.g.beginPath();
      this.g.strokeStyle = r ? this.o.fgColor : this.fgColor;
      // orig                             this.g.arc(this.xy, this.xy, this.radius - this.lineWidth, sat, eat, false);
      this.g.arc(this.xy, this.xy, arcWidth, sat, eat, false);
      this.g.stroke();

      // draw the outer circle
      this.g.lineWidth = 2;
      this.g.beginPath();
      this.g.strokeStyle = this.o.fgColor;
      this.g.arc(this.xy, this.xy, this.radius - this.lineWidth + 1 + this.lineWidth * 2 / 3, 0, 2 * Math.PI, false);
      this.g.stroke();
      // draw an inner circle
      this.g.beginPath();
      this.g.strokeStyle = this.o.fgColor;
      this.g.arc(this.xy, this.xy, this.radius * 1 / 3, 0, 2 * Math.PI, false);
      this.g.stroke();

      // draw a line from center to end
      var len = this.radius; // -this.lineWidth;
      var cosa = Math.cos(a);
      var sina = Math.sin(a);
      var y0 = this.xy - len / 3 * cosa;
      var x0 = this.xy + len / 3 * sina;
      var y1 = this.xy - len * cosa;
      var x1 = this.xy + len * sina;

      this.g.beginPath();
      this.g.moveTo(x0, y0);
      this.g.lineTo(x1, y1);
      this.g.stroke();

      return false;
    };

    // ..................................................
    // closure functions
    var drawFeetOrEars_ = function (drawFeet) {
      let jPreset;
      if (drawFeet == true) {
        jPreset = $('<div/>', {
          'class': us.clsROTATEPRESET + ' us_rotateOne',
          'text': '<',
          'angle': '+1',
          'title': $t('degree-operand', {operand: '+1', forward: ''}),
          css: {left: (divDiamPx / 2 - 4 * presetDiamPx) + 'px', top: (divDiamPx - presetDiamPx) + 'px'}
        });
        jRotationDiv.append(jPreset);
        jPreset = $('<div/>', {
          'class': us.clsROTATEPRESET + ' us_rotateOne',
          'text': '>',
          'angle': '-1',
          'title': $t('degree-operand', {operand: '-1', forward: ' >>'}),
          css: {left: (divDiamPx / 2 + 2 * presetDiamPx) + 'px', top: (divDiamPx - presetDiamPx) + 'px'}
        });
        jRotationDiv.append(jPreset);
      } else {
        jPreset = $('<div/>', {
          'class': us.clsROTATEPRESET + ' us_rotateOne',
          'text': '<',
          'angle': '-1',
          'title': $t('degree-operand', {operand: '+1', forward: ''}),
          css: {left: (divDiamPx / 2 - 4 * presetDiamPx) + 'px', top: '-1px'}
        });
        jRotationDiv.append(jPreset);
        jPreset = $('<div/>', {
          'class': us.clsROTATEPRESET + ' us_rotateOne',
          'text': '>',
          'angle': '+1',
          'title': $t('degree-operand', {operand: '-1', forward: ' >>'}),
          css: {left: (divDiamPx / 2 + 2 * presetDiamPx) + 'px', top: '-1px'}
        });
        jRotationDiv.append(jPreset);
      }
    };
    var drawPresets_ = function () {
      var midVerticalX = (divDiamPx - presetDiamPx) / 2 - 2;
      var midHorizontalY = (divDiamPx - presetDiamPx) / 2 - 1;

      // 0 and 180 degrees
      var jPreset = $('<div/>', {
        'class': us.clsROTATEPRESET,
        'angle': '0',
        'title': $t('degrees', {angle: '0'}),
        css: {left: midVerticalX + 'px', top: '0px'}
      });
      jRotationDiv.append(jPreset);
      jPreset = $('<div/>', {
        'class': us.clsROTATEPRESET,
        'angle': '180',
        'title': $t('degrees', {angle: '180'}),
        css: {left: midVerticalX + 'px', top: (divDiamPx - presetDiamPx - 1) + 'px'}
      });
      jRotationDiv.append(jPreset);

      // 90 and 270 degrees
      jPreset = $('<div/>', {
        'class': us.clsROTATEPRESET,
        'angle': '90',
        'title': $t('degrees', {angle: '90'}),
        css: {left: (dialDiamPx + presetDiamPx - 2) + 'px', top: midHorizontalY + 'px'}
      });
      jRotationDiv.append(jPreset);
      jPreset = $('<div/>', {
        'class': us.clsROTATEPRESET,
        'angle': '270',
        'title': $t('degrees', {angle: '270'}),
        css: {left: '0px', top: midHorizontalY + 'px'}
      });
      jRotationDiv.append(jPreset);
    };
    // ..................................................

    var dialDiamPx = 64;
    var presetDiamPx = 10;
    var divDiamPx = dialDiamPx + 2 * presetDiamPx;

    jRotationDiv = $('<div/>', { // first create an offscreen div that will contain the dial
      class: us.clsROTATIONDIV + ' ' + us.clsOVERLAY + ' ' + us.clsTRANSPARENT,
      title: $t('ui-title'),
      css: {
        left: us.kDEF_TILE_POS_PX,
        top: us.kDEF_TILE_POS_PX,
        width: divDiamPx + 'px',
        height: divDiamPx + 'px'
      }
    });

    drawPresets_(); // draw the presets on the outer ring
    drawFeetOrEars_(true); // draw the feet on the outer ring

    jRotationDial = $('<input/>', { // build the dial
      'class': us.clsROTATIONDIAL,
      'data-skin': 'aperio',
      'readonly': true
    });
    var dialDiamPlus = dialDiamPx + 4;

    var jRotationDivIn = $('<div/>', { // build the rotation dial div
      class: 'us_rotationDivInner' + ' ' + us.clsOVERLAY,
      css: {
        left: '8px',
        top: '8px',
        width: dialDiamPlus + 'px',
        height: dialDiamPlus + 'px'
      }
    });
    jRotationDivIn.append(jRotationDial);
    jRotationDiv.append(jRotationDivIn);
    jVpDiv.append(jRotationDiv);
    jRotationDiv = jVpDiv.find('.' + us.clsROTATIONDIV); // save for quick access
    jPresets = jVpDiv.find('.' + us.clsROTATEPRESET); // save for quick access

    var color = '#556571'; // unfortunately I cannot do this in css
    jRotationDial = jVpDiv.find('.' + us.clsROTATIONDIAL);
    jRotationDial.knob({
      change: self.change,
      release: self.release,
      draw: self.draw,
      width: dialDiamPlus,
      height: dialDiamPlus,
      displayPrevious: true,
      fgColor: color,
      skin: 'aperio',
      cursor: true,
      value: '0',
      thickness: '.2',
      max: 360
    });
    // override the hard coded font in the plug in
    jRotationDial.css({
      'font-size': '9px',
      'font-weight': 'bold',
      'color': color
    });

    viewport.overLayout.add(layout); // and call into layout with parms to place the div
    isLoaded = true;
    self.show(userConfig.get(us.clsROTATIONDIV)); // show/hide according to user preferences
    bindEvents_();

    // ..................................................
    // closure functions
    // ............................................ bindEvents_()
    // bindEvents_ - This function adds the rotation dial event handlers.
    //
    //    Note that by using the same namespace as the viewport when the
    //    viewport removes its events by namespace, these are also removed.
    function bindEvents_ () {
      // TODO: Figure out what this is doing. The control seems to behave just fine without this observer.
      viewport.renderer.addLayer({
        rotateChange ({angleDeg}) {
          const currentAngle = Number(jRotationDial.val());
          if (angleDeg !== currentAngle) {
            self.setValue(angleDeg);
          }
        }
      });

      var namespace = viewport.eventNameSpaceGet();

      // show/hide rotation dial on mode change
      $(us.idHashROOT).on(us.evMODECHANGE + namespace, function (e, parms) {
        // show is true if this is the image selected and not in a mode that I'm supposed to hide during
        var bshow = (viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined);
        self.show(bshow);
      });

      // show/hide rotation dial if image is selected/not-selected
      $(us.idHashROOT).on(us.evIMAGESELECTED + namespace, function (e, parms) {
        self.show(parms.uScopeIdx == viewport.getImageIdx());
      });

      // rotate image
      $(us.idHashROOT).on(us.evIMAGEROTATE + namespace, function (e, parms) {
        // ? do this regardless of user pref?  what about vil settings?

        // if this image is specified or ALL images are specified (parms.uScopeIdx == -1) then perform the rotation
        if (parms.imageId == '@0' || parms.uScopeIdx == -1 || parms.imageId == imageId_ || parms.uScopeIdx == uScopeIdx_) { viewport.viewRotate(parms.angleDeg); }
      });

      // user preference update
      $(us.idHashROOT).on(us.evUSERPREFSREADY + namespace, function (e, parms) {
        self.show(userConfig.get(us.clsROTATIONDIV));

        reLayout(layout.precinct); // layout just this overlay's precinct
      });
      $(us.idHashROOT).on(us.evUSERPREFSET + namespace, function (e, parms) { // parms: {className: STR, value: bool}
        if (parms.className == us.clsROTATIONDIV) {
          self.show(parms.value);
        }
      });

      jPresets.on('click' + namespace, function (e) { // preset click handler
        var angleDeg = parseInt($(this).attr('angle'), 10);
        switch (angleDeg) {
          case 1:
            angleDeg = self.getValue() + 1;
            break;
          case -1:
            angleDeg = self.getValue() - 1;
            break;
          default:
        }
        self.setValue(angleDeg, true);
        return false;
      });
    }
  };

  construct_();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/rotation-dial/rotation-dial-control.js